import type { Money, OpsFunnel } from "../api/console";

/** Zero rows for padding chart series (see fillDays). */
export const EMPTY_MONEY: Money = {
  trips: 0,
  riderPaid: 0,
  grossFare: 0,
  discount: 0,
  driverEarning: 0,
  platformCommission: 0,
  bookingFee: 0,
  latraLevy: 0,
  roundingDifference: 0,
  vatOnCommission: 0,
  vatOnBookingFee: 0,
  gatewayFee: 0,
  tolls: 0,
  platformEarning: 0,
  distanceKm: 0,
  vat: 0,
  rounding: 0,
  takeRate: null,
  avgFare: null,
  avgPlatformPerTrip: null,
  avgDriverPerTrip: null,
};

export const EMPTY_FUNNEL: OpsFunnel = {
  requests: 0,
  completed: 0,
  cancelled: 0,
  notFound: 0,
  riderCancelled: 0,
  driverCancelled: 0,
  fulfilmentRate: null,
  unservedRate: null,
  cancelRate: null,
  avgMinutesToAccept: null,
  avgMinutesToArrive: null,
  avgMinutesWaitAtPickup: null,
  avgMinutesOnTrip: null,
  avgPromisedEta: null,
};
